import { TableHeaders } from "./Headers";

export default class NV03Vare {
    private _id; // VARE_MASTER synthetic id
    private _companyId; // firma_nr
    private _edbNumber; // edb_nr
    private _alpha; // alfa_kode
    private _productNumber; // artikkel_nummer
    private _productNumberClean; // artikkel_nummer_renset
    private _productGroup; // vareGruppe
    private _name; // VareSpes
    private _purchasePrice; // - v_selvkost_pris
    private _salesPrice; //--v_utsalgs_pris
    
    private _priceTypeFlags; //,95,1) as char(1)) v_pt
    private _inStock; //,97,5) as ) v_beholdning
    
    private _processingFlags; // v_behandlingskode //v_bc ,96,1) as char(1)) v_bh char(1)) 
    private _quantityIncoming; //--v_ant_inn
    private _quantityOutgoing; //--v_ant_out
    
    private _quantityPerPackage; // ,[dbo].[unpacknumericbytes](sub([dbo].[vare_master].[data],108,3))
    
    private _remarkFlag; // v_utgaar
    private _deletedFlag; // -- v_slett
    private _location; // v_lplass
    private _surcharge; // v_pristillegg AS (CAST(dbo.unpacknumericbytes(SUB([data], 161, 4)) * .01
    private _supplierPrice; // leverandorpris AS (dbo.unpacknumericbytes(SUB([data], 165, 5)) * .01),
    
    //Transient fields for lk stock levels
    private _lk10; // Hovedlager
    private _lk13; // v_beh_stavanger
    private _lk93; // v_beh_bergen
    private _lk15; // v_beh_trondheim
    private _lk17; // v_beh_tromso
    private _lk92; // v_beh_skien
    private _lk18; // v_beh_kommisjon
    private _ean80; // v_strekkode
    private _minimumStock; // -- v_minimum
    private _reorder; // -- v_rebestill
    private _supplierId80; // vr_levnr1
    private _recommendedPrice80; // vr_vprismm
    private _tableHeaders: TableHeaders[] = [];

    constructor(id = 0, companyId = '', edbNumber = '', alpha = '',
        productNumber = '', productNumberClean = '', productGroup = '', name = '', 
        purchasePrice = '', salesPrice = '', inStock = '', priceTypeFlags = '', processingFlags = '',
        quantityIncoming = '', quantityOutgoing = '', quantityPerPackage = '', 
        supplierPrice = '', remarkFlag = '', deletedFlag = '',
        location = '', surcharge = '',
        lk10 = '', lk13 = '', lk93 = '', lk15 = '', 
        lk17 = '', lk92 = '', lk18 = '',
        ean80 = '', minimumStock = '', reorder = '', supplierId80 = '', recommendedPrice80 = '',
        tableHeaders: TableHeaders[] = []) {
        this._tableHeaders = tableHeaders;
        this._id = id;
        this._companyId = companyId;
        this._edbNumber = edbNumber;
        this._alpha = alpha;
        this._productNumber = productNumber;
        this._productNumberClean = productNumberClean;
        this._productGroup = productGroup;
        this._name = name;
        this._purchasePrice = purchasePrice;
        this._salesPrice = salesPrice;
        this._inStock = inStock;
        this._priceTypeFlags = priceTypeFlags;
        this._processingFlags = processingFlags;
        this._quantityIncoming = quantityIncoming;
        this._quantityOutgoing = quantityOutgoing;
        this._quantityPerPackage = quantityPerPackage;
        this._supplierPrice = supplierPrice;
        this._remarkFlag = remarkFlag;
        this._deletedFlag = deletedFlag;
        this._location = location;
        this._surcharge = surcharge;
        this._lK10 = lK10;
        this._lK13 = lK13;
        this._lK93 = lK93;
        this._lK15 = lK15;
        this._lK17 = lK17;
        this._lK92 = lK92;
        this._lK18 = lK18;
        this._ean80 = ean80;
        this._minimumStock = minimumStock;
        this._reorder = reorder;
        this._supplierId80 = supplierId80;
        this._recommendedPrice80 = recommendedPrice80;
    }

    get id() {
        return this._id;
    }

    get tableHeaders(): TableHeaders[] {
        return this._tableHeaders;
    }

    get companyId(): string {
        return this._companyId ? this._companyId.toUpperCase() : '';
    }

    get edbNumber(): string {
        return this._edbNumber;
    }

    get alpha(): string {
        return this._alpha;
    }

    get productNumber(): string {
        return this._productNumber;
    }

    get productNumberClean(): string {
        return this._productNumberClean;
    }

    get productGroup(): string {
        return this._productGroup;
    }

    get name(): string {
        return this._name;
    }

    get purchasePrice(): string {
        return this._purchasePrice;
    }

    get salesPrice(): string {
        return this._salesPrice;
    }

    get priceTypeFlags(): string {
        return this._priceTypeFlags;
    }

    get processingFlags(): string {
        return this._processingFlags;
    }

    get quantityIncoming(): string {
        return this._quantityIncoming;
    }

    get quantityOutgoing(): string {
        return this._quantityOutgoing;
    }

    get quantityPerPackage(): string {
        return this._quantityPerPackage;
    }

    get supplierPrice(): string {
        return this._supplierPrice;
    }

    get remarkFlag(): string {
        return this._remarkFlag;
    }

    get surcharge(): string {
        return this._surcharge;
    }

    get minimumStock(): string {
        return this._minimumStock;
    }

    get recommendedPrice80(): string {
        return this._recommendedPrice80;
    }

    get location(): string {
        return this._location;
    }

    get deletedFlag(): string {
        return this._deletedFlag;
    }

    get inStock(): string {
        return this._inStock;
    }

    get lk10(): string {
        return this._lk10;
    }

    get lk13(): string {
        return this._lk13;
    }

    get lk15(): string {
        return this._lk15;
    }
    get lk17(): string {
        return this._lk17;
    }

    get lk18(): string {
        return this._lk18;
    }

    get lk92(): string {
        return this._lk92;
    }

    get lk93(): string {
        return this._lk93;
    }

    get reorder(): string {
        return this._reorder;
    }

    get ean80(): string {
        return this._ean80;
    }
    
    get supplierId80(): string {
        return this._supplierId80;
    }

}
export class NV03Firma {

    public _id: number;
    private _firmId: string;
    private _lK10: string;
    private _lK13: string;
    private _lK93: string;
    private _lK15: string;
    private _lK17: string;
    private _lK92: string;
    private _lK18: string;
     [key: string]: any; // Add this line

    constructor(id = 0, firmId = '', lK10 = '', lK13 = '', lK93 = '', lK15 = '', lK17 = '', lK92 = '', lK18 = '') {
        this._id = id;
        this._firmId = firmId;
        this._lK10 = lK10;
        this._lK13 = lK13;
        this._lK93 = lK93;
        this._lK15 = lK15;
        this._lK17 = lK17;
        this._lK92 = lK92;
        this._lK18 = lK18;
    }

    get id(): number {
        return this._id;
    }

    get firmId(): string {
        return this._firmId.toUpperCase();
    }

    get lK10(): string {
        return this._lK10;
    }

    get lK13(): string {
        return this._lK13;
    }

    get lK93(): string {
        return this._lK93;
    }

    get lK15(): string {
        return this._lK15;
    }

    get lK17(): string {
        return this._lK17;
    }

    get lK92(): string {
        return this._lK92;
    }

    get lK18(): string {
        return this._lK18;
    }

}
